import { render, staticRenderFns } from "./TransactionRow.vue?vue&type=template&id=03b9f44e&scoped=true&"
import script from "./TransactionRow.vue?vue&type=script&lang=js&"
export * from "./TransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRow.vue?vue&type=style&index=0&id=03b9f44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9f44e",
  null
  
)

export default component.exports